export default __webpack_public_path__ + "static/nara-fc3070e1154cebc5d3c0189d2677a10f.png";